import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    baseUrl: String
  }

  navigate(event) {
    const sortValue = event.target.value
    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set("sort", sortValue)

    // Preserve existing filter params
    const currentUrl = new URL(window.location.href)
    const name = currentUrl.searchParams.get("name")
    if (name) url.searchParams.set("name", name)

    currentUrl.searchParams.getAll("ext[]").forEach(v => url.searchParams.append("ext[]", v))
    currentUrl.searchParams.getAll("pipeline[]").forEach(v => url.searchParams.append("pipeline[]", v))

    Turbo.visit(url.toString(), { action: "replace" })
  }
}
